import React, { useState } from "react";
import { Transition } from "@headlessui/react";
import { IoAnalyticsOutline } from 'react-icons/io';

function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div>
      <nav className="">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 ">
            <div className="flex items-center">
              <div className="flex-shrink-0 flex ">
               
              <svg className="w-14 h-14 md:text-brightRed text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
        
              </div>
              <div className="hidden md:block text-blue-600">
                <div className="ml-10 flex items-baseline space-x-6 text-blue-600">
                <a
                  href="#header"
                  className="text-blue-600 hover:bg-gray-700 hover:text-white  block px-3 py-2 rounded-md text-base font-medium"
                >
                  About
                </a>

                <a
                  href="#about"
                  className="text-blue-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                >
                  Serivices
                </a>

                <a
                  href="#work"
                  className="text-blue-6000 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                >
                  Projects
                </a>
                <a
                  href="#skills"
                  className="text-blue-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                >
                 Skills
                </a>

                <a
                  href="#testimonial"
                  className="text-blue-600 hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                >
                 Testimonals
                </a>
    

        
                <a
          href="#contact"
          class="hidden p-2 px-6 pt-2  text-white bg-brightRed rounded-full baseline hover:bg-brightRedLight md:block"
          >Get In Touch</a
        >
       
                </div>
              </div>
            </div>
            <div className="-mr-2 flex md:hidden">
              <button
                onClick={() => setIsOpen(!isOpen)}
                type="button"
                className="bg-blue-600 inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-white hover:bg-blue-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                aria-controls="mobile-menu"
                aria-expanded="false"
              >
                <span className="sr-only">Open main menu</span>
                {!isOpen ? (
                  <svg
                    className="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  </svg>
                ) : (
                  <svg
                    className="block h-6 w-6"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                )}
              </button>
            </div>
          </div>
        </div>

        <Transition
          show={isOpen}
          enter="transition duration-100 ease-out"
          enterFrom="transform scale-95 opacity-0"
          enterTo="transform scale-100 opacity-100"
          leave="transition duration-75 ease-out"
          leaveFrom="transform scale-100 opacity-100"
          leaveTo="transform scale-95 opacity-0"
         
        >
          {(ref) => (
            <div className=" md:hidden" id="mobile-menu">
              <div ref={ref} className=" px-2 pt-2 pb-3 space-y-1 sm:px-3">
              <a
                  href="#headers"
                  className="hover:bg-gray-700 text-veryDarkBlue block px-3 py-2 rounded-md text-base font-medium"
                >
                  About
                </a>

                <a
                  href="#about"
                  className="text-veryDarkBlue  hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                >
                  Serivices
                </a>

                <a
                  href="#work"
                  className="text-veryDarkBlue  hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                >
                  Projects
                </a>
                <a
                  href="#skills"
                  className="text-veryDarkBlue  hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                >
                 Skills
                </a>

                <a
                  href="#testimonial"
                  className="text-veryDarkBlue  hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                >
                 Testimonals
                </a>

                <a
                  href="#contact"
                  className="text-veryDarkBlue  hover:bg-gray-700 hover:text-white block px-3 py-2 rounded-md text-base font-medium"
                >
                 Get in touch
                </a>
                
              </div>
            </div>
          )}
        </Transition>
      </nav>

     
      
    </div>
  );
}

export default Nav;
